import { Component, Input } from '@angular/core';
import { LovableTrendingTopic } from './lovable-dashboard.models';

@Component({
    selector: 'app-lovable-trending-topics-panel',
    templateUrl: './lovable-trending-topics-panel.component.html',
    styleUrls: ['./lovable-trending-topics-panel.component.css'],
})
export class LovableTrendingTopicsPanelComponent {
    @Input() topics: LovableTrendingTopic[] = [];
}
